module.exports = __webpack_public_path__ + "media/Varilux_COMFORT.71c83140.mp4";